import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import user from './user';
import story from './story';
import card from './card';
import editor from './editor';
import settings from './settings';

const rootReducer = combineReducers({
	user,
	story,
	card,
	editor,
	settings,
	form: formReducer,
});

export type ClientReducerState = ReturnType<typeof rootReducer>;

export default rootReducer;
